export default __webpack_public_path__ + "static/highlightsBg-a910d3d667e247292de1de3d10a308e7.png";